import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['toggleable', 'lazyToggleable'];

  connect() {
    this.toggleClass = this.data.get('class') || 'hidden';
  }

  toggle(event) {
    if(!this.data.get('process-default'))
      event.preventDefault();

    this.toggleableTargets.forEach(target => {
      target.classList.toggle(this.toggleClass);
    });

    this.lazyToggleableTargets.forEach(target => {
      target.classList.toggle(this.toggleClass);
    });

    if (!this.lazyHTML) {
      fetch(this.data.get('url'))
        .then(response => response.text())
        .then(html => {
          this.lazyHTML = html;

          this.lazyToggleableTargets.forEach(target => {
            target.innerHTML = this.lazyHTML;
          });
        });
    }
  }
}
